/*
 * File: TalentForm.tsx
 * Project: a-a
 * File Created: Monday, 22nd September 2025 6:39:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 28th November 2025 11:40:56 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import validator from 'validator';
import CustomAlert from '../../../../../components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../../../components/shared/CustomAlert/CustomAlertContain';
import CustomAutocomplete from '../../../../../components/shared/CustomAutocomplete/CustomAutocomplete';
import CustomButton from '../../../../../components/shared/CustomButton/CustomButton';
import CustomCheckbox from '../../../../../components/shared/CustomCheckbox/CustomCheckbox';
import CustomDatePicker from '../../../../../components/shared/CustomDatePicker/CustomDatePicker';
import CustomTextField from '../../../../../components/shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../../customHook/useInput';
import { ClientService } from '../../../../../service/client.service';
import { HuddleClientService } from '../../../../../service/huddle-client.service';
import { LocationService } from '../../../../../service/location.service';
import zeplinColor from '../../../../../theme/Color';
import { ClientType } from '../../../../../utilities/constants';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const TalentForm = ({
  handleSelection,
  setSelectedItems,
  selectedItems,
  data,
  getAllClient,
  onClose,
  platformSelected,
}: {
  handleSelection: (item: any, type: string | boolean) => void;
  setSelectedItems: React.Dispatch<
    React.SetStateAction<{
      salutation: string[];
      agency: any[];
      league: string[];
      team: string[];
      position: string[];
      number: string[];
      status: string[];
      college: string[];
      time: string[];
      client: boolean[];
      type: string[];
      industry: string[];
      category: string[];
      captiv8: any[];
    }>
  >;
  selectedItems: {
    salutation: string[];
    agency: any[];
    league: string[];
    team: string[];
    position: string[];
    number: string[];
    status: string[];
    college: string[];
    time: string[];
    client: boolean[];
    type: string[];
    industry: string[];
    category: string[];
    captiv8: any[];
  };
  data?: any;
  getAllClient: () => Promise<void>;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  platformSelected: string | undefined;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const wait = useRef<any>();
  const [formLoading, setFormLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [date, setDate] = useState<Dayjs | null>(data?.birthdate ? dayjs(data?.birthdate) : null);

  const [dropdowns, setDropdowns] = useState<any>({});
  const [client, setClient] = useState(data ? data?.isPersonAccount : true);
  const [sameBilling, setSameBilling] = useState(false);
  const [agencyData, setAgencyData] = useState<any[]>([]);
  const [selectedAddressSuggestion, setSelectedAddressSuggestion] = useState({ Name: '', ID: '' });
  const [billingSuggestion, setBillingSuggestion] = useState({ Name: '', ID: '' });
  const [address, setAddress] = useState<any[]>([]);
  const [captiv8, setCaptiv8] = useState<any[]>([]);
  const totalAgencyLength = 50;
  const salutation: { [key: string]: string } = {
    Mr: 'Mr',
    Mrs: 'Mrs',
    Ms: 'Ms',
    Dr: 'Dr',
    Prof: 'Prof',
  };
  const suggestionAPI = async (value: string) => {
    try {
      setLoading(true);
      const res = await LocationService.getAddressSuggestion(value?.toLocaleLowerCase());
      console.log(res);
      setAddress(res.map((val: any) => ({ Id: val?.description, Name: val?.description })));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSearch = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    const getSuggestion = setTimeout(() => suggestionAPI(value), 1000);
    wait.current = getSuggestion;
  };
  const suggestionCaptiv8API = async (value: string) => {
    try {
      setLoading(true);
      const res = await ClientService.searchCaptiv8(value?.toLocaleLowerCase());
      console.log(res);
      setCaptiv8(
        res?.users?.map((val: any) => ({
          Id: val?.captiv8Id,
          Name: val?.name,
          avatar: val?.avatar,
          followers: val?.followers,
        })),
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCaptiv8Search = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    if (value) {
      const getSuggestion = setTimeout(() => suggestionCaptiv8API(value), 1000);
      wait.current = getSuggestion;
    }
  };
  const {
    handleChange: handleFirstNameChange,
    handleBlur: handleFirstNameBlur,
    clearInput: clearFirstName,
    value: firstName,
    invalid: invalidFirstName,
    didChange: didFirstNameChange,
  } = useInput(data ? data?.accountName : '', () => true);
  const {
    handleChange: handleLastNameChange,
    handleBlur: handleLastNameBlur,
    clearInput: clearLastName,
    value: lastName,
    invalid: invalidLastName,
    didChange: didLastNameChange,
  } = useInput(data ? data?.lastName : '', () => true);
  const {
    handleChange: handleImdbChange,
    handleBlur: handleImdbBlur,
    clearInput: clearImdb,
    value: imdb,
    invalid: invalidImdb,
    didChange: didImdbChange,
  } = useInput(data ? data?.imdbPro : '', () => true);
  const {
    handleChange: handleLoanChange,
    handleBlur: handleLoanBlur,
    clearInput: clearLoan,
    value: loan,
    invalid: invalidLoan,
    didChange: didLoanChange,
  } = useInput(data?.loanOutCompany ? data?.loanOutCompany : '', () => true);
  const {
    handleChange: handleMobileChange,
    handleBlur: handleMobileBlur,
    clearInput: clearMobile,
    value: mobile,
    invalid: invalidMobile,
    didChange: didMobileChange,
  } = useInput(data?.mobile ? data?.mobile : '', () => true);
  const {
    handleChange: handlePhoneChange,
    handleBlur: handlePhoneBlur,
    clearInput: clearPhone,
    value: phone,
    invalid: invalidPhone,
    didChange: didPhoneChange,
  } = useInput(data ? data?.phone : '', () => true);
  const {
    handleChange: handleEmailChange,
    handleBlur: handleEmailBlur,
    clearInput: clearEmail,
    value: email,
    invalid: invalidEmail,
    didChange: didEmailChange,
  } = useInput(data ? data?.email : '', validator.isEmail);
  const {
    handleChange: handlePersonalEmailChange,
    handleBlur: handlePersonalEmailBlur,
    clearInput: clearPersonalEmail,
    value: personalEmail,
    invalid: invalidPersonalEmail,
    didChange: didPersonalEmailChange,
  } = useInput(data ? data?.personalEmail : '', validator.isEmail);
  const {
    handleChange: handleStreetChange,
    handleBlur: handleStreetBlur,
    setValue: setStreet,
    clearInput: clearStreet,
    value: street,
    invalid: invalidStreet,
    didChange: didStreetChange,
  } = useInput(data?.mailingAddress?.street ? data?.mailingAddress?.street : '', () => true);
  const {
    handleChange: handleCityChange,
    handleBlur: handleCityBlur,
    clearInput: clearCity,
    setValue: setCity,
    value: city,
    invalid: invalidCity,
    didChange: didCityChange,
  } = useInput(data?.mailingAddress?.city ? data?.mailingAddress?.city : '', () => true);
  const {
    handleChange: handleStateChange,
    handleBlur: handleStateBlur,
    clearInput: clearState,
    setValue: setState,
    value: state,
    invalid: invalidState,
    didChange: didStateChange,
  } = useInput(data?.mailingAddress?.state ? data?.mailingAddress?.state : '', () => true);
  const {
    handleChange: handleZipChange,
    handleBlur: handleZipBlur,
    clearInput: clearZip,
    setValue: setZip,
    value: zip,
    invalid: invalidZip,
    didChange: didZipChange,
  } = useInput(
    data?.mailingAddress?.postalCode ? data?.mailingAddress?.postalCode : '',
    () => true,
  );
  const {
    handleChange: handleCountryChange,
    handleBlur: handleCountryBlur,
    clearInput: clearCountry,
    setValue: setCountry,
    value: country,
    invalid: invalidCountry,
    didChange: didCountryChange,
  } = useInput(data?.mailingAddress?.country ? data?.mailingAddress?.country : '', () => true);

  const {
    handleChange: handleBillingStreetChange,
    handleBlur: handleBillingStreetBlur,
    clearInput: clearBillingStreet,
    value: billingStreet,
    setValue: setBillingStreet,
    invalid: invalidBillingStreet,
    didChange: didBillingStreetChange,
  } = useInput(data?.billingAddress?.street ? data?.billingAddress?.street : '', () => true);

  const {
    handleChange: handleBillingCityChange,
    handleBlur: handleBillingCityBlur,
    clearInput: clearBillingCity,
    setValue: setBillingCity,
    value: billingCity,
    invalid: invalidBillingCity,
    didChange: didBillingCityChange,
  } = useInput(data?.billingAddress?.city ? data?.billingAddress?.city : '', () => true);

  const {
    handleChange: handleBillingStateChange,
    handleBlur: handleBillingStateBlur,
    clearInput: clearBillingState,
    setValue: setBillingState,
    value: billingState,
    invalid: invalidBillingState,
    didChange: didBillingStateChange,
  } = useInput(data?.billingAddress?.state ? data?.billingAddress?.state : '', () => true);
  const {
    handleChange: handleBillingZipChange,
    handleBlur: handleBillingZipBlur,
    clearInput: clearBillingZip,
    setValue: setBillingZip,
    value: billingZip,
    invalid: invalidBillingZip,
    didChange: didBillingZipChange,
  } = useInput(
    data?.billingAddress?.postalCode ? data?.billingAddress?.postalCode : '',
    () => true,
  );
  const {
    handleChange: handleBillingCountryChange,
    handleBlur: handleBillingCountryBlur,
    clearInput: clearBillingCountry,
    setValue: setBillingCountry,
    value: billingCountry,
    invalid: invalidBillingCountry,
    didChange: didBillingCountryChange,
  } = useInput(data?.billingAddress?.country ? data?.billingAddress?.country : '', () => true);
  const {
    handleChange: handleBioChange,
    handleBlur: handleBioBlur,
    clearInput: clearBio,
    value: bio,
    invalid: invalidBio,
    didChange: didBioChange,
  } = useInput(data ? data?.bio : '', () => true);

  const handleDeleteItems = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    // const {
    //   target: { value },
    // } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: [...selectedItems.agency?.filter((val: any) => val !== item)],
    });
  };
  const handleAgencyFilter = (e: React.SyntheticEvent, value: string) => {
    // if (value) {
    //   const filter = agencyData?.filter((e) =>
    //     e?.Name?.toLocaleLowerCase()?.includes(value.toLocaleLowerCase()),
    //   );
    //   setAgencyData(filter);
    // } else {
    //   setAgencyData([...dropdowns?.agency]);
    // }
  };
  const handleClientFilter = (e: React.SyntheticEvent, value: string) => {
    // if (value) {
    //   const filter = captiv8?.filter((e) =>
    //     e?.Name?.toLocaleLowerCase()?.includes(value.toLocaleLowerCase()),
    //   );
    //   setCaptiv8(filter);
    // } else {
    //   setCaptiv8([...dropdowns?.captiv8]);
    // }
  };
  const handleAgencyScroll = () => {
    // setAgencyData([...dropdowns?.agency]);
  };
  const handleClientScroll = () => {
    // setAgencyData([...dropdowns?.agency]);
  };
  const getDropdownValue = async (type: string) => {
    try {
      let res;
      if (platformSelected === 'Huddle' || data?.source === 'HUDDLE') {
        res = await HuddleClientService.getHuddleClientDropdowns(type);
      } else {
        res = await ClientService.getClientDropdowns(type);
      }
      console.log(res);
      setDropdowns(res);
      setAgencyData(res?.agency);
      // setCaptiv8(res?.captiv8);
    } catch (err) {
      console.error(err);
    }
  };
  const addClient = async () => {
    try {
      setFormLoading(true);
      const props = {
        Name: `${firstName} ${lastName}`,
        RecordTypeName: ClientType.Talent,
        ...(date && { PersonBirthdate: date }),
        ...(selectedItems?.captiv8[0] && { Captive8_Creator_Id__c: selectedItems?.captiv8[0]?.Id }),
        RecordTypeId: '012E0000000ef5iIAA',
        GD_IMDBPro__c: imdb,
        PersonMobilePhone: mobile,
        GD_Bio__c: bio,
        BillingAddress: {
          city: sameBilling ? city : billingCity,
          country: sameBilling ? country : billingCountry,
          state: sameBilling ? state : billingState,
          street: sameBilling ? street : billingStreet,
          postalCode: sameBilling ? zip : billingZip,
        },
        PersonMailingAddress: {
          city: city,
          country: country,
          state: state,
          street: street,
          postalCode: zip,
        },
        Client__c: client,
        ...(selectedItems?.agency?.length && {
          Agency__c: selectedItems?.agency[0]?.Id,
        }),
        // agency: selectedItems?.agency[0]?.ID,
        ...(mobile && { PersonMobilePhone: mobile }),
        ...(phone && { phone }),
        ...(selectedItems?.league[0] &&
          selectedItems?.league[0] !== 'None' && { League__c: selectedItems.league[0] || '' }),
        ...(selectedItems?.team[0] &&
          selectedItems?.team[0] !== 'None' && { Team__c: selectedItems.team[0] || '' }),
        ...(selectedItems?.position[0] &&
          selectedItems?.position[0] !== 'None' && {
            Position__c: selectedItems.position[0] || '',
          }),
        ...(selectedItems?.status[0] &&
          selectedItems?.status[0] !== 'None' && { Status__c: selectedItems.status[0] || '' }),
        ...(selectedItems?.college[0] &&
          selectedItems?.college[0] !== 'None' && { College__c: selectedItems.college[0] || '' }),
        Personal_Email__pc: personalEmail,
        PersonEmail: email,
        Loan_Out_Company__c: loan,
        // IsPersonAccount: client,
        // Industry: 'Fashion',
        ...(selectedItems?.type[0] &&
          selectedItems?.type[0] !== 'None' && { Type: selectedItems.type[0] || '' }),
      };

      let res;
      if (platformSelected === 'Huddle' || location?.pathname?.includes('huddle')) {
        res = data?.accountId
          ? await HuddleClientService?.editHuddleClient(props, data?.accountId)
          : await HuddleClientService.addHuddleClient(props);
        client && sessionStorage.setItem('platform', 'huddle');
      } else {
        res = data?.accountId
          ? await ClientService.editClient(props, data?.accountId)
          : await ClientService.addClient(props);
      }
      client && sessionStorage.setItem('new-client', res?.recordIdres?.recordId || res?.clientId);
      getAllClient();
      onClose(false);
    } catch (err) {
      setError(true);
    } finally {
      setFormLoading(false);
    }
  };

  const disable = !(firstName && selectedItems?.agency[0]);
  useEffect(() => {
    getDropdownValue(ClientType.Talent);
  }, []);
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Account Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Salutation
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                // multiple
                value={
                  typeof selectedItems.salutation == 'string'
                    ? selectedItems.salutation
                    : selectedItems.salutation[0]
                }
                onChange={(e) => handleSelection(e, 'salutation')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Salutation'
                  />
                }
                renderValue={(selected) => {
                  // console.log(selected);
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Salutation ?? []), 'None'].map((name: string) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.salutation.indexOf(name) > -1} // Check if this radio should be selected
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomTextField
              style={{ width: '100%', flex: { xs: 2, xl: 3 } }}
              onBlur={handleFirstNameBlur}
              onChange={handleFirstNameChange}
              name='Name'
              text={firstName}
              form={true}
              error={invalidFirstName && didFirstNameChange ? 'Please enter valid First Name' : ''}
              label={'Name'}
              type='text'
              tabindex={1}
              required
            />
          </Box>
          {/* <CustomTextField
            style={{ width: '100%', flex: 3 }}
            onBlur={handleLastNameBlur}
            onChange={handleLastNameChange}
            name='Last Name'
            text={lastName}
            form={true}
            error={
              error
                ? error
                : invalidLastName && didLastNameChange
                ? 'Please enter valid Last Name'
                : ''
            }
            label={'Last Name'}
            type='text'
            tabindex={1}
            required
          /> */}
          <CustomDatePicker
            value={date}
            setValue={setDate}
            label='Birth date'
            size={isXs ? 'small' : 'medium'}
          />
          <CustomAutocomplete
            popupIcon='/assets/Search.svg'
            required={true}
            options={agencyData || []}
            // getOptionLabel={(option: any) =>
            //   Object.keys(option)?.length ? Object.keys(option)[0] : ''
            // }
            getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
            label={'Agency'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              handleSelection(value, 'agency');
            }}
            value={selectedItems?.agency[0]}
            handleFilter={handleAgencyFilter}
            placeholder='Search agency'
            currentLength={dropdowns?.agency?.length}
            totalLength={dropdowns?.agency?.length}
            next={handleAgencyScroll}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleImdbBlur}
              onChange={handleImdbChange}
              name='IMDBPro'
              text={imdb}
              form={true}
              error={invalidImdb && didImdbChange ? 'Please enter valid Imdb' : ''}
              label={'IMDBPro'}
              // type='number'
              tabindex={1}
              // required
            />
            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Type
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                // multiple
                value={
                  typeof selectedItems.type == 'string' ? selectedItems.type : selectedItems.type[0]
                }
                onChange={(e) => handleSelection(e, 'type')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Type'
                  />
                }
                renderValue={(selected) => {
                  // console.log(selected);
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Type ?? []), 'None'].map((name: string) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.type.indexOf(name) > -1} // Check if this radio should be selected
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <CustomTextField
            style={{ width: '100%', flex: 3 }}
            onBlur={handleLoanBlur}
            onChange={handleLoanChange}
            name='Loan out company'
            text={loan}
            form={true}
            error={invalidLoan && didLoanChange ? 'Please enter valid First Name' : ''}
            label={'Loan out company'}
            type='text'
            tabindex={1}
            // required
          />
          {platformSelected === 'Salesforce' && (
            <CustomCheckbox
              label='Client'
              checked={client} // Controlled state
              onChange={(checked) => {
                setClient(checked); // Update local state
                handleSelection('client', checked); // Pass the updated state to the parent component
              }}
            />
          )}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Contact Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleMobileBlur}
              onChange={handleMobileChange}
              name='Mobile'
              text={mobile}
              form={true}
              error={invalidMobile && didMobileChange ? 'Please enter valid Mobile' : ''}
              label={'Mobile'}
              tabindex={1}
              // required
              isPhoneMask
            />
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handlePhoneBlur}
              onChange={handlePhoneChange}
              name='Phone'
              text={phone}
              form={true}
              error={invalidPhone && didPhoneChange ? 'Please enter valid Phone' : ''}
              label={'Phone'}
              tabindex={1}
              // required
              isPhoneMask
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleEmailBlur}
              onChange={handleEmailChange}
              name='Email'
              text={email}
              form={true}
              error={invalidEmail && didEmailChange ? 'Please enter valid Email' : ''}
              label={'Email'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handlePersonalEmailBlur}
              onChange={handlePersonalEmailChange}
              name='Personal Email'
              text={personalEmail}
              form={true}
              error={
                invalidPersonalEmail && didPersonalEmailChange
                  ? 'Please enter valid Personal Email'
                  : ''
              }
              label={'Personal Email'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Mailing Address
          </Typography>
          {/* <CustomSearch setProjects={setAddress} getProjects={(text: string) => {}} /> */}
          <CustomAutocomplete
            loading={loading}
            popupIcon='/assets/Search.svg'
            required={false}
            options={address || []}
            getOptionLabel={(option: any) => option?.Name}
            label={'Search address'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              setSelectedAddressSuggestion(value);
              setStreet(value?.Name.split(',')[0]);

              setCity(value?.Name.split(',')[value?.Name.split(',')?.length - 3]);
              setState(value?.Name.split(',')[value?.Name.split(',')?.length - 2]);
              setCountry(value?.Name.split(',')[value?.Name.split(',')?.length - 1]);
            }}
            value={selectedAddressSuggestion}
            handleFilter={handleAddressSearch}
            placeholder='Search address'
            currentLength={address?.length || 0}
            totalLength={address?.length || 0}
            next={handleAgencyScroll}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleStreetBlur}
              onChange={handleStreetChange}
              name='Street'
              text={street}
              form={true}
              error={invalidStreet && didStreetChange ? 'Please enter valid Street' : ''}
              label={'Street'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleCityBlur}
              onChange={handleCityChange}
              name='City'
              text={city}
              form={true}
              error={invalidCity && didCityChange ? 'Please enter valid City' : ''}
              label={'City'}
              type='text'
              tabindex={1}
              // required
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleStateBlur}
              onChange={handleStateChange}
              name='State/Province'
              text={state}
              form={true}
              error={invalidState && didStateChange ? 'Please enter valid State' : ''}
              label={'State/Province'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleZipBlur}
              onChange={handleZipChange}
              name='Zip/Postal code'
              text={zip}
              form={true}
              error={invalidZip && didZipChange ? 'Please enter valid Zip' : ''}
              label={'Zip/Postal code'}
              type='number'
              tabindex={1}
              // required
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleCountryBlur}
              onChange={handleCountryChange}
              name='Country'
              text={country}
              form={true}
              error={invalidCountry && didCountryChange ? 'Please enter valid Country' : ''}
              label={'Country'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Billing Address
          </Typography>
          <CustomCheckbox
            label='Billing address is same as my mailing address'
            checked={sameBilling} // Controlled state
            onChange={(checked) => {
              setSameBilling(checked); // Update local state
              // handleSelection('client', checked); // Pass the updated state to the parent component
            }}
          />
          {/* <CustomSearch setProjects={setAddress} getProjects={(text: string) => {}} /> */}
          <CustomAutocomplete
            loading={loading}
            popupIcon='/assets/Search.svg'
            required={false}
            options={address || []}
            getOptionLabel={(option: any) => option?.Name}
            label={'Address'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              setBillingSuggestion(value);
              setBillingStreet(value?.Name.split(',')[0]);

              setBillingCity(value?.Name.split(',')[value?.Name.split(',')?.length - 3]);
              setBillingState(value?.Name.split(',')[value?.Name.split(',')?.length - 2]);
              setBillingCountry(value?.Name.split(',')[value?.Name.split(',')?.length - 1]);
            }}
            value={billingSuggestion}
            handleFilter={handleAddressSearch}
            placeholder='Search address'
            currentLength={address?.length || 0}
            totalLength={address?.length || 0}
            next={handleAgencyScroll}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStreetBlur}
              onChange={handleBillingStreetChange}
              name='Street'
              text={sameBilling ? street : billingStreet}
              form={true}
              error={
                invalidBillingStreet && didBillingStreetChange ? 'Please enter valid Street' : ''
              }
              label={'Street'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCityBlur}
              onChange={handleBillingCityChange}
              name='City'
              text={sameBilling ? city : billingCity}
              form={true}
              error={invalidBillingCity && didBillingCityChange ? 'Please enter valid City' : ''}
              label={'City'}
              type='text'
              tabindex={1}
              // required
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStateBlur}
              onChange={handleBillingStateChange}
              name='State/Province'
              text={sameBilling ? state : billingState}
              form={true}
              error={invalidBillingState && didBillingStateChange ? 'Please enter valid State' : ''}
              label={'State/Province'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingZipBlur}
              onChange={handleBillingZipChange}
              name='Zip/Postal code'
              text={sameBilling ? zip : billingZip}
              form={true}
              error={invalidBillingZip && didBillingZipChange ? 'Please enter valid Zip' : ''}
              label={'Zip/Postal code'}
              type='number'
              tabindex={1}
              // required
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCountryBlur}
              onChange={handleBillingCountryChange}
              name='Country'
              text={sameBilling ? country : billingCountry}
              form={true}
              error={
                invalidBillingCountry && didBillingCountryChange ? 'Please enter valid Country' : ''
              }
              label={'Country'}
              type='text'
              tabindex={1}
              // required
            />
          </Box>
          <CustomTextField
            style={{ width: '100%' }}
            onBlur={handleBioBlur}
            onChange={handleBioChange}
            name='Bio'
            text={bio}
            form={true}
            error={false}
            label={'Bio'}
            multiline
            type='text'
            tabindex={1}
            // required
          />
        </Box>
        {/* {data?.accountId ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
            <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
              Captiv8 connect
            </Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
              Use the search bar to find your client in Captiv8 and connect them to access insights
              directly in the Huddle.
            </Typography>
            <CustomAutocomplete
              loading={loading}
              popupIcon='/assets/Search.svg'
              required={false}
              options={captiv8 || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Search client'}
              handleDeleteItems={handleDeleteItems}
              selectedItems={selectedItems}
              handleSelection={(value) => {
                handleSelection(value, 'captiv8');
              }}
              value={selectedItems?.captiv8[0]}
              handleFilter={handleCaptiv8Search}
              placeholder='Search client'
              currentLength={captiv8?.length}
              totalLength={captiv8?.length}
              next={handleClientScroll}
              multiple={false}
            />
          </Box>
        ) : (
          ''
        )} */}
      </Box>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px 0px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomButton
          disabled={disable || formLoading}
          onClick={() => {
            addClient();
          }}
          variant='contained'
          color={disable ? 'customDisable' : 'primary'}
          style={{
            borderRadius: '14px',
            height: 56,
            width: '100%',
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: disable ? zeplinColor.Neutral8 : zeplinColor.Neutral1 }}
          text={
            formLoading
              ? data?.accountId
                ? 'Saving'
                : 'Creating Client...'
              : data?.accountId
              ? 'Save'
              : 'Create Client'
          }
          // tabindex={4}
        />
      </Box>
      <CustomAlert
        open={error}
        handleClose={() => {
          setError(false);
        }}
        message={
          <CustomAlertContain
            alertIcon={<img src='/assets/error.svg' width={24} height={24} />}
            alert={'Something went wrong.'}
            error
          />
        }
        error
      />
    </>
  );
};

export default TalentForm;
